import { AfterViewInit, Component, OnDestroy } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { MagnetService } from '@mirage-projects/cw-commons';

import { UploadWizardService } from '../../../services/upload-wizard-service/upload-wizard.service';

/**
 * This is the create project wizard second step where the user can set the name and the captureDate of the project
 */
@Component({
    selector: 'cw-create-project-wizard-project-data',
    templateUrl: './create-project-wizard-project-data.component.html',
    standalone: false,
})
export class CreateProjectWizardProjectDataComponent implements AfterViewInit, OnDestroy {
    label = 'CREATE_PROJECT.NAME';
    onDestroy$: Subject<void> = new Subject();
    today = new Date();

    constructor(
        public uploadWizardService: UploadWizardService,
        private magnetService: MagnetService
    ) {}

    ngAfterViewInit(): void {
        this.uploadWizardService.stepChanged.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.updateSummary();
        });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    updateSummary(): void {
        this.uploadWizardService.summary[1] = {
            title: 'WIZARD.TAB_NEW_PROJECT',
            fields: [
                { key: 'CREATE_PROJECT.NAME', value: this.uploadWizardService.getProjectName() ?? '' },
                {
                    key: 'CREATE_PROJECT.CAPTURE_DATE',
                    value: this.uploadWizardService.getFormattedCaptureDate(this.uploadWizardService.projectForm, 'longDate') ?? '',
                },
            ],
        };
    }

    /* istanbul ignore next */
    /**
     * Only show capture date when not in Collage Site
     */
    get hasToShowCaptureDate(): boolean {
        return !this.magnetService.isSite();
    }
}
